import {Action, getModule, Module, VuexModule} from "vuex-module-decorators";
import store from "@/store";
import ModuleApi from "@/store/api";
import {PromocodeRs} from "@/types/promocodes";
import {mapToPromocodeDto} from "@/mappers/promocodes";

@Module({
    name: 'promocodes',
    namespaced: true,
    dynamic: true,
    store
})
class ModulePromocodes extends VuexModule {

    //Get all available specialist promocodes
    @Action
    async getAllSpecialistPromocodes() {
        const response = await ModuleApi.GET('/api/cabinet/promocodes/') as PromocodeRs[];
        return mapToPromocodeDto(response);
    }
}

export default getModule(ModulePromocodes)
